import React from 'react';

import { SuiContainer } from '@splashthat/sui';

const FormEditorNodeDropzone = (props) => <SuiContainer className="FormEditorNodeDropzone" />;

export default FormEditorNodeDropzone;
